// extracted by mini-css-extract-plugin
export default {"LoadingLanguages":"hbIKIX8FacCHO0XjSvsg","fadein":"ZLmmLeZd2SiK3OQd3Boe"};